export const LAW_COLOR = "rgb(24, 79, 128)"
export const NON_LAW_COLOR = "#56b231"
